import React, { FC, useCallback, useContext } from 'react';
import { IBasicOrganization } from '../../resources/models/IOrganization';
import Dialog from '@mui/material/Dialog';
import { useTranslation } from 'react-i18next';
import { apiUser } from '../../resources/api/apiUser';
import { ChooseOrganization } from '../ChooseOrganization/ChooseOrganization';
import { OrganizationContext } from '../../contexts/OrganizationContext';
import { AuthContext } from '../../contexts/AuthContext';
import { useApiErrorHandler } from '../../hooks/useApiErrorHandler';
import { CurrentUserContext } from '../../contexts/CurrentUserContext';

interface IProps {
  open: boolean;
  onClose: () => void;
}

const { useUpdateDefaultOrganization } = apiUser;

export const ChooseOrganizationModal: FC<IProps> = ({ open, onClose }) => {
  const { t } = useTranslation();
  const handleError = useApiErrorHandler();

  const { setOrganization } = useContext(OrganizationContext);
  const { identity } = useContext(AuthContext);
  const { refetchUserInfo } = useContext(CurrentUserContext);

  const { execute: setDefaultOrganization } = useUpdateDefaultOrganization(identity?.userId);

  const onSubmit = useCallback(
    async (org: IBasicOrganization, setDefault: boolean) => {
      try {
        setOrganization(org);
        if (setDefault) {
          await setDefaultOrganization(org);
          await refetchUserInfo();
        }
        onClose();
      } catch (e) {
        handleError(e);
      }
    },
    [onClose]
  );

  const onSkip = useCallback(() => {
    setOrganization(null);
    onClose();
  }, []);

  return (
    <Dialog open={open} onClose={onClose}>
      <ChooseOrganization
        cancelText={t('chooseOrganization.modal.cancel')}
        cancelAction={onClose}
        submitText={t('chooseOrganization.modal.submit')}
        submitAction={onSubmit}
        noOrgText={t('chooseOrganization.modal.skip')}
        noOrgAction={onSkip}
      />
    </Dialog>
  );
};
